import { render, staticRenderFns } from "./InvoiceRelated.vue?vue&type=template&id=316689de&scoped=true&"
import script from "./InvoiceRelated.vue?vue&type=script&lang=js&"
export * from "./InvoiceRelated.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&id=316689de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316689de",
  null
  
)

export default component.exports